import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useEmsProjectsTreeData from "../Drawers/TreeViewDrawer/useEmsProjectsTreeData";
import EmsProjectsTreeView from "../Drawers/TreeViewDrawer/EmsProjectsTreeView";

/**
 * The Plant -> WBS -> Documents/Estimation/Drawings tree, as a section
 * inside AppSidebar (see AppSidebar/index.jsx) — the app's primary way to
 * reach a project once you're past the top-level sections. Selecting a
 * WBS/Document node here always navigates to that plant's DCS page (the
 * Document Register lives there); selecting the Plant node itself does not
 * navigate anywhere — with `focusSelectedPlant`, that click already
 * expands/focuses the tree on that plant, which is all it's meant to do
 * here. Unlike the full-page EmsExplorer, which shows the same tree
 * alongside inline content instead of navigating away. Only rendered for
 * users with at least one plant module (see AppSidebar's
 * `hasAnyModule(ALL_PLANT_MODULE_NAMES)` gate) so the data hooks below
 * never fire for users without plant access.
 */
export default function ProjectsTreeSection() {
  const navigate = useNavigate();
  const location = useLocation();
  // Derived from the URL rather than taken as a prop, since this panel is
  // mounted globally above the routed page - not every page has a plantId,
  // and when one does it's this panel's only way to know it.
  const currentPlantId = useMemo(
    () => location.pathname.match(/^\/plant\/([^/]+)/)?.[1],
    [location.pathname],
  );

  const treeData = useEmsProjectsTreeData();

  const handleSelect = (target) => {
    if (target.kind === "plant") return;
    navigate(`/plant/${target.plant.id}/dcs`);
  };

  return (
    <EmsProjectsTreeView
      data={treeData}
      activePlantId={currentPlantId}
      onSelect={handleSelect}
      showLegend={false}
      collapsible
      defaultListOpen
      focusSelectedPlant
    />
  );
}
